import React, { useState } from 'react'
import { NavLink  } from 'react-router-dom'
import './Navbar.css';

function Navbar1() {

    const [isMobile, setIsMobile] = useState(false);

    return (
        <>
            <header className="header">
                <div id="header-top-bar" className="primary-bg py-2">
                    <div className="container">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-md-7 col-lg-7 d-none d-md-block d-lg-block">
                                <div className="topbar-text text-white">
                                    <ul className="list-inline">
                                        <li className="list-inline-item"><span className="fas fa-headphones-alt mr-1"></span> 24x7 Technical Support</li>
                                        <li className="list-inline-item"><span className="fas fa-phone-alt mr-1"></span> 992-034-1097</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4">
                                <div className="topbar-text text-white">
                                    <ul className="list-inline text-md-right text-lg-right text-left  mb-0">
                                        <li className="list-inline-item">
                                            <a href="https://www.facebook.com/octaveinfosys" className="rounded" rel="noreferrer" target="_blank" ><span className="fab fa-facebook-f"></span></a>
                                        </li>
                                        <li className="list-inline-item"><a href="https://twitter.com/InfosysOctave" className="rounded" rel="noreferrer" target="_blank" ><span
                                            className="fab fa-twitter"></span></a>
                                        </li>
                                        <li className="list-inline-item"><a href="https://www.instagram.com/websiteunique/" className="rounded" rel="noreferrer" target="_blank" ><span
                                            className="fab fa-instagram"></span></a>
                                        </li>
                                        <li className="list-inline-item"><a href="https://www.linkedin.com/company/octave-infosys" className="rounded" rel="noreferrer" target="_blank" ><span
                                            className="fab fa-linkedin-in"></span></a>
                                        </li>
                                        <li className="list-inline-item"><a href="https://www.youtube.com/channel/UCoknOgtTmzcjZPzFwBZ9Wdg" className="rounded" rel="noreferrer" target="_blank" ><span
                                            className="fab fa-youtube"></span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <nav className='navbar navbar-expand-lg fixed-top white-bg'>
                    <div className="container">
                        <NavLink className="navbar-brand" to="Website-Desgn">
                            <img src="assets1/img/logo.png" alt="logo" className="img-fluid" />
                        </NavLink>
                        <ul className={isMobile ? "nav-link-mobile ml-auto menu" : "menu"}
                            onClick={() => setIsMobile(false)}>
                            <li><NavLink  to="Website-Desgn"> Home</NavLink >
                            </li>
                            <li><NavLink  to="about">About Us</NavLink ></li>
                            <li><NavLink  to="services">Services</NavLink ></li>
                            <li><NavLink  to="work">Work Portfolio</NavLink ></li>
                            <li><NavLink  to="contact">Contact Us</NavLink ></li>

                            <li><a className="btn secondary-solid-btn check-btn" rel="noreferrer" target="_blank" href="https://dbcards.in" >Digital Visiting Card</a></li>
                        </ul>
                        <button className="mobile-menu-icon" onClick={() => setIsMobile(!isMobile)}>
                            {isMobile ? (<i className='fas fa-times'></i>) : (<i className='fas fa-bars'></i>)}

                        </button>
                    </div>
                </nav>
            </header>
        </>

    )
}

export default Navbar1
